const VARS = {
  API_URL: "https://devsud.fonetricks.com/api",
  SOCKET_URL: "https://devsud.fonetricks.com"
}

export default VARS